import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";

// A table-level "saving…" affordance for the employment / publications editors. The Add flow is
// non-optimistic and its editor row collapses the instant the create fires (NewEmploymentLine /
// NewPublicationLine call setAdding(false) before the request resolves), so while the create + reload
// run there is no row on screen to hang a spinner on — the indicator has to live at the table level.
// Rendered as a full-width row so it shows whether the table has rows or is empty. Sized to match
// SaveSpinnerButton's 1.25rem spinner.
function InlinePendingRow({ isPending = false, colSpan = "999" }) {
  if (!isPending) return null;

  return (
    <tr>
      <td colSpan={colSpan} className="text-muted">
        <Spinner
          animation="border"
          className="me-2"
          role="status"
          variant="secondary"
          style={{ width: "1.25rem", height: "1.25rem" }}
        />
        Saving…
      </td>
    </tr>
  );
}

export default InlinePendingRow;

InlinePendingRow.propTypes = {
  isPending: PropTypes.bool,
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
